<div class="card card-custom gutter-b card-fit" data-card="true">
  <div class="card-header">
    <div class="card-title">
      <button type="button" class="btn btn-light mr-3" (click)="backToInvoice()">
        <i class="las la-arrow-left"></i>
      </button>
      <h3 class="card-label" (click)="sampleClick()">Payment Register Screen</h3>
    </div>
    <div class="card-toolbar d-flex align-items-center justify-content-between">

       
      <button type="button" class="btn font-weight-bold btn-secondary ml-3" (click)="getHostedToken()">
        <i class="las la-envelope-open-text"></i> Send Payment Link
      </button>
      <button type="button" class="btn font-weight-bold btn-secondary ml-3" (click)="openEmailModal()">
        <i class="las la-envelope-open-text"></i> Email to Client
      </button>
      <button type="button" class="btn font-weight-bold btn-primary ml-3" (click)="FinalizeInvoice()">
        <i class="las la-receipt"></i> Finalize
      </button>

    </div>

  </div>
  <div class="card-body  mt-0 py-5 px-5 ">

    <div class="row">
      <div class="col-7">
        <!-- Left: Payment list -->
        <div class="card" style="min-height: 300px;">
          <div class="card-body">
            <ul class="nav nav-tabs mb-2">
              <li class="nav-item">
                <a class="nav-link" [class.active]="initialTabActive" (click)="checkPetDetailsTab_All()">
                  <i class="las la-list-ul"></i> All
                </a>
              </li>
              <li class="nav-item" *ngFor="let item of invoiceService.pet_to_invoice_list; let i = index">
                <a class="nav-link" [class.active]="!initialTabActive && i === pet_to_invoice_index"
                  (click)="checkPetDetailsTab(i,item)">
                  <i class="las la-paw"></i> {{ item.pet_name }} &nbsp;
                </a>
              </li>
            </ul>

            <div style="max-height:420px; overflow-y:auto;">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col" width="20%">Amount</th>
                    <th scope="col" width="30%">Method</th>
                    <th scope="col" width="30%">Method Detail</th>
                    <th scope="col" width="20%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let payments of invoiceService.payment_forms; let i = index">
                    <ng-container *ngIf="initialTabActive || (payments.pet_no === pet_to_invoice_item.pet_no)">
                      <td>
                        <div class="d-flex align-items-center">
                          <span>$</span>
                          <input class="form-control form-control-solid ml-2" type="number"
                            [(ngModel)]="payments.amount" step="0.01">
                        </div>
                      </td>
                      <td>
                        <input class="form-control form-control-solid ml-2" type="text"
                          [name]="'_methods' + payments.pet_no" [value]="setMethodCodeByNo(payments.method)">
                      <td>
                        <input class="form-control form-control-solid ml-2" type="text"
                          [name]="'_methodsdets' + payments.pet_no" [(ngModel)]="payments.method_dets">
                      </td>
                      <td>
                        <button type="button" class="btn btn-danger" (click)="deletePayment(i)"><i
                            class="las la-trash"></i></button>
                      </td>
                    </ng-container>
                  </tr>
                  <tr style="background-color: aliceblue;" *ngIf="!initialTabActive"
                    (keydown.tab)="handleTabKeyPress($event)">
                    <td>
                      <div class="d-flex align-items-center">
                        <span>$</span>
                        <input class="form-control ml-2" type="text" [(ngModel)]="payment_form.amount">
                      </div>
                    </td>
                    <td>
                      <select class="form-control form-control" name="_status" [(ngModel)]="payment_form.method"
                        (change)="fillMethodDetails($event.target.value)">
                        <option value=""></option>
                        <option *ngFor="let item of methods" [value]="item.method_no">{{item.method_code}}</option>
                      </select>
                    <td>
                      <input type="text" class="form-control" name="_method_dets"
                        [(ngModel)]="payment_form.method_dets">
                    </td>
                    <td>
                      <button type="button" class="btn btn-primary" (click)="ReceivePayment()">Receive</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Discounts below main table -->
        <div class="card mt-3">
          <div class="card-header"><b>Discounts</b></div>
          <div class="card-body">
            <div class="form-check form-check-inline" *ngFor="let item of managerialService.discounts">
              <input class="form-check-input" type="radio" name="_discount" [id]="'dis' + item.discount_desc"
                [value]="item.discount_percent" (change)="handleDiscountChange($event.target.value)">
              <label class="form-check-label" [for]="'dis' + item.discount_desc">{{item.discount_desc}}</label>
            </div>
            <div class="form-check form-check-inline mt-2">
              <input class="form-check-input" type="radio" name="_discount" id="inlineRadio2"
                (change)="handleDiscountChange('CD')">
              <label class="form-check-label" for="inlineRadio2">Other (%)</label>
              <input type="number" class="form-control" name="customDiscount" style="max-width: 80px; margin-left: 8px;"
                [(ngModel)]="customDiscount" value="0" [disabled]="selectedDiscount !== 'CD'"
                (change)="handleDiscountChange('CD')">
            </div>
          </div>
        </div>
      </div>

      <div class="col-5 d-flex">
        <div class="d-flex flex-column mr-2" style="flex:1;">
          <div class="card flex-fill h-100" *ngIf="invoiceService.payment_Details_list[pet_to_invoice_index]">
            <div class="card-body" style="overflow:auto;">
              <h5 class="card-title">{{pet_to_invoice_item.pet_name}} Bill Calculation</h5>
              <p>Actual Charge: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].actual_charge |
                  number:'1.2-2'}}</b></p>
              <p>Total Charge: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].total_charge |
                  number:'1.2-2'}}</b></p>
              <p>Discount: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].Discount |
                  number:'1.2-2'}}</b></p>
              <p>Tax: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].total_tax | number:'1.2-2'}}</b>
              </p>
              <p>Prior Balance: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].prior_balance |
                  number:'1.2-2'}}</b></p>
              <p>Deposit: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].deposit | number:'1.2-2'}}</b>
              </p>
              <p>Balance Due: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].balance_due |
                  number:'1.2-2'}}</b></p>
              <p>Amount Paid: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].amount_paid |
                  number:'1.2-2'}}</b></p>
              <h6>Current Balance: <b>{{invoiceService.payment_Details_list[pet_to_invoice_index].current_balance |
                  number:'1.2-2'}}</b></h6>


            </div>
          </div>
        </div>
        <div class="d-flex flex-column" style="flex:1;">
          <div class="card flex-fill h-100" *ngIf="invoiceService.payment_Details_list[pet_to_invoice_index]">
            <div class="card-body" style="overflow:auto;">
              <h5 class="card-title">Total Bill Calculation</h5>
              <p>Total Charge: <b>{{invoiceService.payment_Details.total_charge | number:'1.2-2'}}</b></p>
              <p>Discount: <b>{{invoiceService.payment_Details.Discount | number:'1.2-2'}}</b></p>
              <p>Tax: <b>{{(invoiceService.currentClient_Nonprofit)? 'Exempt (Nonprofit)':
                  invoiceService.payment_Details.total_tax | number:'1.2-2'}}</b></p>
              <p>Prior Balance: <b>{{invoiceService.payment_Details.prior_balance}}</b></p>
              <p>Balance Due: <b>{{invoiceService.payment_Details.balance_due | number:'1.2-2'}}</b></p>
              <p>Amount Paid: <b>{{invoiceService.payment_Details.amount_paid | number:'1.2-2'}}</b></p>
              <p>Coupon: <b>{{invoiceService.payment_Details.coupon | number:'1.2-2'}}</b></p>
              <p>Clinic Account: <b>{{invoiceService.payment_Details.clinic_account | number:'1.2-2'}}</b></p>
              <div class="form-group row">
                <label for="staticEmail" class="col-sm-4 col-form-label">Change: </label>
                <div class="col-sm-8">
                  <div class="input-group mb-2 d-flex" *ngIf="invoiceService.payment_Details.change === 0">
                    <input type="text" class="form-control" style="color: #D5D8DC;" [(ngModel)]="partial_change"
                      readonly>
                    <div class="input-group-append flex" (click)="calculateChange()">
                      <div class="input-group-text"><i class="las la-hand-holding-usd"></i></div>
                    </div>
                  </div>
                  <div class="input-group mb-2 d-flex" *ngIf="invoiceService.payment_Details.change !== 0">
                    <input type="text" class="form-control" [(ngModel)]="invoiceService.payment_Details.change"
                      readonly>
                    <div class="input-group-append flex" (click)="changebtn_reset()">
                      <div class="input-group-text"><i class="las la-redo-alt"></i></div>
                    </div>
                  </div>
                </div>
              </div>
              <h6>Current Balance: <b>{{invoiceService.payment_Details.current_balance | number:'1.2-2'}}</b></h6>

              <hr class="mt-7 mb-2">
              
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" name="_emailInvReciept" [(ngModel)]="invoiceService.emailInvReciept">
                <label class="form-check-label" for="inlineCheckbox1" > Email Invoice Receipt to Client</label>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>














  <!-- <div class="modal fade" id="modalEmail" tabindex="-1" role="dialog" aria-labelledby="modalEmail"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalEmail">Send Bill to Client</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body"> 
                <div [innerHTML]="clientService.email_service.Body"></div>
            </div> 
        </div>
    </div>
</div> -->

  <div class="modal fade" id="modalActiveRabiesVaccine" tabindex="-1" role="dialog"
    aria-labelledby="modalActiveRabiesVaccine" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false"
    data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalActiveRabiesVaccine">Rabies and Neuter Details</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="max-height: 360px; overflow-y: auto;">

          <ng-container *ngFor="let item of pets_with_rabies">
            <div class="card mb-2">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <h5 class="card-title mb-1">{{item.pet_name}} <small class="text-muted">({{item.pet_no}})</small></h5>
                </div>

                <div class="form-group mt-2" *ngIf="item.rabies >= 1">
                  <label for="rabieTagNo-{{item.pet_no}}">Rabie Tag no</label>
                  <input name="rabieTagNo-{{item.pet_no}}" type="text" class="form-control"
                    [(ngModel)]="item.rabies_tag_no" />
                </div>

                <div class="form-group mt-2" *ngIf="item.rabies >= 1">
                  <label for="cityLicense-{{item.pet_no}}">City License</label>
                  <select id="cityLicense-{{item.pet_no}}" class="form-control" name="cityLicense-{{item.pet_no}}"
                    [(ngModel)]="item.city_license">
                    <option value="0">Don't need City License</option>
                    <option *ngFor="let cityLicense of invoiceService.cityLicense" [value]="cityLicense.link_no">
                      {{cityLicense.cert_name}} (Price: ${{cityLicense.cert_cost | number:'1.2-2'}})</option>
                  </select>
                </div>

                <div class="form-group mt-2" *ngIf="item.neuter >= 1">
                  <label for="alteredPet-{{item.pet_no}}">Mark this pet as altered?</label>
                  <select id="alteredPet-{{item.pet_no}}" class="form-control" name="alteredPet-{{item.pet_no}}"
                    [(ngModel)]="item.altered_pet">
                    <option value=""></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </select>
                </div>

              </div>
            </div>
          </ng-container>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="confirmRabiesVaccine()">Continue</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modalPostInvoice" tabindex="-1" role="dialog" aria-labelledby="modalPostInvoiceLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalPostInvoiceLabel">Post-Invoice Actions</h5>
        </div>
        <div class="modal-body" style="max-height: 600px; overflow-y: auto;">

          <!-- Section 2: Pet Tags & Appointments -->
          <ng-container *ngIf="hasAfterInvoiceItems">
            <h6 class="mb-2">Set Items Done After Invoicing</h6>
            <ng-container *ngFor="let item of petToBeDeletedItems">
              <div class="card mb-2"
                *ngIf="(item.tag_id && item.tag_id > 0) || (item.appointment_id && item.appointment_id > 0)">
                <div class="card-body py-2">
                  <h6 class="mb-1">{{item.pet_name}} <small class="text-muted">({{item.pet_no}})</small></h6>
                  <div class="form-group form-check mb-1" *ngIf="item.tag_id && item.tag_id > 0">
                    <input type="checkbox" class="form-check-input" id="_pi_tag_{{item.pet_no}}"
                      [(ngModel)]="item.selectedTag">
                    <label class="form-check-label" for="_pi_tag_{{item.pet_no}}">Release Tag {{item.tag_display}}</label>
                  </div>
                  <div class="form-group form-check mb-0"
                    *ngIf="item.appointment_id && item.appointment_id > 0">
                    <input type="checkbox" class="form-check-input" id="_pi_appt_{{item.pet_no}}"
                      [(ngModel)]="item.selectedAppt">
                    <label class="form-check-label" for="_pi_appt_{{item.pet_no}}">Appointment</label>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!-- Section 1: Unfinished Transactions -->
          <ng-container *ngIf="deletetran_question.length > 0">
            <h6 class="text-danger mb-1">Unfinished Transactions</h6>
            <p class="small text-muted mb-2">Select transactions to <b>DELETE</b>:</p>

            <div class="d-flex align-items-center mb-2">
              <div class="form-check mr-3">
                <input class="form-check-input" type="checkbox" id="pi-requested-checkbox"
                  (change)="toggleStatusItems('R', $event)">
                <label class="form-check-label" for="pi-requested-checkbox">Requested</label>
              </div>
              <div class="form-check mr-3">
                <input class="form-check-input" type="checkbox" id="pi-queued-checkbox"
                  (change)="toggleStatusItems('Q', $event)">
                <label class="form-check-label" for="pi-queued-checkbox">Quoted</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="pi-client-checkbox"
                  (change)="toggleStatusItems('C', $event)">
                <label class="form-check-label" for="pi-client-checkbox">Client Request</label>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover table-sm">
                <thead>
                  <tr>
                    <td style="width: 40px">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" (change)="toggleAllItems($event)"
                          [checked]="areAllItemsSelected()">
                      </div>
                    </td>
                    <th>Pet</th>
                    <th>Code</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of deletetran_question">
                    <td>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="item.selected">
                      </div>
                    </td>
                    <td>{{ item.pet_no }}</td>
                    <td>{{ item.code_name }}</td>
                    <td>
                      <span [ngSwitch]="item.status">
                        <span *ngSwitchCase="'T'">Treatment</span>
                        <span *ngSwitchCase="'R'">Requested</span>
                        <span *ngSwitchCase="'S'">Suggested</span>
                        <span *ngSwitchCase="'Q'">Quoted</span>
                        <span *ngSwitchCase="'C'">Client Request</span>
                        <span *ngSwitchDefault>Unknown</span>
                      </span>
                    </td>
                    <td>{{ item.req_date | date:'MM/dd/yyyy, hh:mm a' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr *ngIf="hasAfterInvoiceItems" />
          </ng-container> 

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="dismissPostInvoiceModal()">Skip & Continue</button>
          <button type="button" class="btn btn-primary" (click)="confirmPostInvoice()">
            <i class="las la-check-circle"></i> Confirm & Continue
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modalCardPay" tabindex="-1" role="dialog" aria-labelledby="modalCardPayLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <ngx-card-pay></ngx-card-pay>
      </div>
    </div>
  </div>